import { render, staticRenderFns } from "./orderEdit.vue?vue&type=template&id=48123304&scoped=true"
import script from "./orderEdit?vue&type=script&lang=js&external"
export * from "./orderEdit?vue&type=script&lang=js&external"
import style0 from "./orderEdit.vue?vue&type=style&index=0&id=48123304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48123304",
  null
  
)

export default component.exports